/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-unused-vars */
import React, { useContext, useState } from 'react';
// eslint-disable-next-line no-unused-vars
import styled from 'styled-components/macro';
import Button from '../../atoms/Button';

import { Banner, TextBox, Title, BtnHolder, InputFile, Label } from './KickOffBanner.style';
import Loaders from '../../atoms/Loaders';

import { compressImage } from '../../../helpers/common';
import Toast from '../../molecules/Toast';
import CampaignService from '../../../services/promotionsService';

function KickOffBanner({ onClose }) {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [img, setImg] = useState(null);
  const handleUpload = () => {
    setLoading(true);
    try {
      if (!file) {
        Toast({ type: 'error', message: 'Please upload an image' });
        setLoading(false);
        return;
      }
      if (file) {
        if (!/[/.](gif|jpg|jpeg|tiff|png)$/i.test(file?.name)) {
          setLoading(false);
          Toast({ type: 'error', message: 'Only images are allowed' });
        } else if (file?.name) {
          compressImage(file)
            .then(async res => {
              setImg(prev => ({ ...prev, custom_logo: res }));
              const response = await CampaignService.uploadKickOffImg({
                img: res,
                fileName: file?.name.split('.')[0] ?? 'kick_off_img',
              });
              setLoading(false);

              Toast({
                type: 'success',
                message: response?.message ?? 'Successfully uploaded an  image',
              });
              onClose();
            })
            .catch(err => {
              setImg(prev => ({ ...prev, custom_logo: null }));
              setLoading(false);
              Toast({
                type: 'error',
                message: err?.message,
              });
            });
        }
      }
    } catch (error) {
      setLoading(false);

      Toast({
        type: 'error',
        message: error?.message,
      });
    }
  };
  const onFileChange = files => {
    // eslint-disable-next-line no-shadow
    const file = files[0];
    if (!/[/.](gif|jpg|jpeg|tiff|png)$/i.test(file?.name)) {
      Toast({ type: 'error', message: 'Only images are allowed' });
    } else if (file?.name) {
      compressImage(file)
        .then(async res => {
          setImg(prev => ({ ...prev, custom_logo: res }));
        })
        .catch(err => {
          setImg(prev => ({ ...prev, custom_logo: null }));
          Toast({
            type: 'error',
            message: err?.message,
          });
        });
    }
  };

  return (
    <>
      <Loaders>
        <Banner>
          {/* <Button
            className="btn"
            type="outline"
            size={40}
            sm
            shape="circle"
            disabled={loading}
            onClick={() => {
              setShowKickOffUpload(false);
            }}>
            <span className="material-icons-outlined">clear</span>
          </Button> */}
          <TextBox>
            <p>
              Upload a kickoff promotion image. Maximum file size of 25MB. Please ensure that the file is in JPG format.
            </p>
          </TextBox>
          <InputFile style={{ backgroundImage: `url(${img?.custom_logo})` }}>
            {!file && <span className="material-icons-outlined">file_upload</span>}
            <Label htmlFor="file" isFile={file}>
              {file ? (
                <span>
                  <span className="material-icons-outlined">delete</span>
                  Clear
                </span>
              ) : (
                'Upload from Computer'
              )}
            </Label>
            {/* <span>{file?.name}</span> */}
            <input
              className="uploadFile"
              type="file"
              id="file"
              name="store"
              onChange={({ target: { files } }) => {
                setFile(files[0]);
                onFileChange(files);
              }}
            />
          </InputFile>
          <BtnHolder>
            <Button
              type="primary"
              sm
              rounded
              loading={loading}
              width={150}
              onClick={() => {
                handleUpload();
              }}>
              Upload
            </Button>
          </BtnHolder>
        </Banner>
      </Loaders>
    </>
  );
}

export default KickOffBanner;
